import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { useFormikContext } from "formik";
import downArrow from "./../../resources/down_arrow.png";

const roles = ["Assignor", "Contractor", "Supervisor"];

const CustomSelect = ({ name }: { name: string }) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const selected = values[name];

  const handleSelect = (value: string) => {
    setFieldValue(name, value);
  };

  return (
    <Menu as="div" className="relative w-full">
      <MenuButton className="border border-gray-300 rounded p-2 w-full bg-white text-left flex justify-between items-center">
        <span className={selected ? "text-[#101828]" : "text-[#667085]"}>
          {selected || "Select Role"}
        </span>
        <img src={downArrow} alt="Arrow" className="w-5 h-5" />
      </MenuButton>
      <MenuItems className="absolute mt-1 w-full border border-gray-300 rounded bg-white shadow-lg z-10 text-[#101828]">
        {roles.map((role) => (
          <MenuItem key={role} as="div">
            <button
              type="button"
              onClick={() => handleSelect(role)}
              className="w-full text-left p-2 "
            >
              {role}
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};

export default CustomSelect;
